import { useEffect } from "react";

/**
 * Mientras el usuario esté dentro de /agua, apunta el <link rel="manifest"> al
 * manifest propio del módulo (manifest-agua.json).
 *
 * Es la alternativa al subdominio agua.corvana.net: misma app, mismo dominio,
 * misma sesión y misma base de datos, pero al instalarla desde estas pantallas
 * el celular la guarda como una app aparte ("Lecturas de Agua", ícono azul,
 * abre directo en /agua) en vez de como un acceso directo a Corvana completo.
 *
 * Al salir del módulo se restaura el manifest original de Corvana.
 */
export default function useManifestAgua() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return undefined;

    const anterior = link.getAttribute("href");
    link.setAttribute("href", "/manifest-agua.json");

    // El color de la barra del navegador también cambia a azul mientras
    // estamos en el módulo.
    const meta = document.querySelector('meta[name="theme-color"]');
    const colorAnterior = meta ? meta.getAttribute("content") : null;
    if (meta) meta.setAttribute("content", "#0284c7");

    // iOS ignora el manifest al "Agregar a inicio": toma el ícono de
    // apple-touch-icon y el nombre de apple-mobile-web-app-title, así que hay
    // que cambiarlos aparte o el iPhone instalaría el logo de Corvana.
    const touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const iconAnterior = touchIcon ? touchIcon.getAttribute("href") : null;
    if (touchIcon) touchIcon.setAttribute("href", "/AGUA-ICON.png");

    let titulo = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const tituloCreado = !titulo;
    if (!titulo) {
      titulo = document.createElement("meta");
      titulo.setAttribute("name", "apple-mobile-web-app-title");
      document.head.appendChild(titulo);
    }
    const tituloAnterior = titulo.getAttribute("content");
    titulo.setAttribute("content", "Agua");

    return () => {
      if (anterior) link.setAttribute("href", anterior);
      if (meta && colorAnterior) meta.setAttribute("content", colorAnterior);
      if (touchIcon && iconAnterior) touchIcon.setAttribute("href", iconAnterior);
      if (tituloCreado) titulo.remove();
      else if (tituloAnterior) titulo.setAttribute("content", tituloAnterior);
    };
  }, []);
}
